"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactCustomScrollbars = require("react-custom-scrollbars-2");

var ST = _interopRequireWildcard(require("./styled"));

var _excluded = ["customStyles", "hideTracksWhenNotNeeded"],
    _excluded2 = ["style"],
    _excluded3 = ["style"],
    _excluded4 = ["style"],
    _excluded5 = ["style"],
    _excluded6 = ["style"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CustomScrollbar = function CustomScrollbar(_ref) {
  var _ref$customStyles = _ref.customStyles,
      customStyles = _ref$customStyles === void 0 ? {} : _ref$customStyles,
      _ref$hideTracksWhenNo = _ref.hideTracksWhenNotNeeded,
      hideTracksWhenNotNeeded = _ref$hideTracksWhenNo === void 0 ? true : _ref$hideTracksWhenNo,
      props = _objectWithoutProperties(_ref, _excluded);

  var RenderView = function RenderView(_ref2) {
    var style = _ref2.style,
        props = _objectWithoutProperties(_ref2, _excluded2);

    return /*#__PURE__*/_react["default"].createElement(ST.View, _extends({
      extStyle: style,
      customStyles: customStyles
    }, props));
  };

  var RenderTrackHorizontal = function RenderTrackHorizontal(_ref3) {
    var style = _ref3.style,
        props = _objectWithoutProperties(_ref3, _excluded3);

    return /*#__PURE__*/_react["default"].createElement(ST.TrackHorizontal, _extends({
      extStyle: style,
      customStyles: customStyles
    }, props));
  };

  var RenderTrackVertical = function RenderTrackVertical(_ref4) {
    var style = _ref4.style,
        props = _objectWithoutProperties(_ref4, _excluded4);

    return /*#__PURE__*/_react["default"].createElement(ST.TrackVertical, _extends({
      extStyle: style,
      customStyles: customStyles
    }, props));
  };

  var RenderThumbHorizontal = function RenderThumbHorizontal(_ref5) {
    var style = _ref5.style,
        props = _objectWithoutProperties(_ref5, _excluded5);

    return /*#__PURE__*/_react["default"].createElement(ST.ThumbHorizontal, _extends({
      extStyle: style,
      customStyles: customStyles
    }, props));
  };

  var RenderThumbVertical = function RenderThumbVertical(_ref6) {
    var style = _ref6.style,
        props = _objectWithoutProperties(_ref6, _excluded6);

    return /*#__PURE__*/_react["default"].createElement(ST.ThumbVertical, _extends({
      extStyle: style,
      customStyles: customStyles
    }, props));
  };

  return /*#__PURE__*/_react["default"].createElement(_reactCustomScrollbars.Scrollbars, _extends({
    renderView: RenderView,
    renderTrackHorizontal: RenderTrackHorizontal,
    renderTrackVertical: RenderTrackVertical,
    renderThumbHorizontal: RenderThumbHorizontal,
    renderThumbVertical: RenderThumbVertical,
    hideTracksWhenNotNeeded: hideTracksWhenNotNeeded
  }, props));
};

CustomScrollbar.propTypes = {
  customStyles: _propTypes["default"].shape({
    view: _propTypes["default"].object,
    trackVertical: _propTypes["default"].object,
    thumbVertical: _propTypes["default"].object,
    trackHorizontal: _propTypes["default"].object,
    thumbHorizontal: _propTypes["default"].object
  }),
  hideTracksWhenNotNeeded: _propTypes["default"].bool
};
var _default = CustomScrollbar;
exports["default"] = _default;